import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DriverLoc } from '../models/socket.model';

@Injectable({ providedIn: 'root' })
export class TrackingSocketService {
  private readonly trackingSocketSubject =
    new BehaviorSubject<DriverLoc | null>(null);

  /** stream for components */
  trackingSocket$: Observable<DriverLoc | null> =
    this.trackingSocketSubject.asObservable();

  /** push socket data */
  setTrackingSocket(value: DriverLoc | null): void {
    this.trackingSocketSubject.next(value);
  }

  /** reset stream so subscribers do not replay stale tracking data */
  clearTrackingSocket(): void {
    this.trackingSocketSubject.next(null);
  }

  /** optional snapshot access */
  getSnapshot(): DriverLoc | null {
    return this.trackingSocketSubject.value;
  }
}
